import React from 'react';
import { cx } from '@emotion/css';
import { Paper, IconButton } from '@mui/material';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import colors from '@/theme/colors';
import { VariantEnum } from '@/config/constants';
import { BodyLargeEmphasized } from '../Typography';
import styles from './FloatingNotification.styles';

interface Props {
  children: React.ReactNode;
  variant: VariantEnum;
}

export const FloatingNotification = React.forwardRef<HTMLDivElement, Props>(
  ({ children, variant }, ref) => {
    const variantIcons = {
      success: <CheckCircleOutlineOutlinedIcon />,
      info: <InfoOutlinedIcon />,
      warning: <ErrorOutlineOutlinedIcon />,
      error: <CancelOutlinedIcon />,
    };

    return (
      <div ref={ref} className={styles.container}>
        <Paper className={cx(styles.paper, styles.variants[variant])}>
          <IconButton className={cx(styles.icon, styles.iconVariants[variant])}>
            {variantIcons[variant]}
          </IconButton>
          <BodyLargeEmphasized color={colors.charcoal}>{children}</BodyLargeEmphasized>
        </Paper>
      </div>
    );
  }
);
